<div class="audit-history-container">
  <div class="filter-section">
    <mat-form-field appearance="outline">
      <mat-label>Filter by Field</mat-label>
      <mat-select [formControl]="fieldFilterControl">
        <mat-option value="">All Fields</mat-option>
        <mat-option *ngFor="let field of availableFields" [value]="field.value">
          {{ field.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="audit-table">

      <ng-container matColumnDef="tabName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Tab Name
          <app-table-column-filter class="column-filter" [class.active]="isActive('tabName')" (filterChange)="filterTabdleCol($event, 'tabName')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ row.tabName| formatFieldName  }}</td>
      </ng-container>

      <ng-container matColumnDef="fieldName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Field Name
          <app-table-column-filter class="column-filter" [class.active]="isActive('fieldName')" (filterChange)="filterTabdleCol($event, 'fieldName')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ row.fieldName | formatFieldName }}</td>
      </ng-container>

      <ng-container matColumnDef="oldValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Old Value
          <app-table-column-filter class="column-filter" [class.active]="isActive('oldValue')" (filterChange)="filterTabdleCol($event, 'oldValue')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ getFormattedValue(row.fieldName, row.oldValue) | stripHtml }}</td>
      </ng-container>

      <ng-container matColumnDef="newValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          New Value
          <app-table-column-filter class="column-filter" [class.active]="isActive('newValue')" (filterChange)="filterTabdleCol($event, 'newValue')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ getFormattedValue(row.fieldName, row.newValue) | stripHtml }}</td>
      </ng-container>

      <ng-container matColumnDef="changedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Changed By
          <app-table-column-filter class="column-filter" [class.active]="isActive('changedBy')" (filterChange)="filterTabdleCol($event, 'changedBy')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ row.changedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="changedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Changed Date
          <app-table-column-filter class="column-filter" [class.active]="isActive('changedDate')" (filterChange)="filterTabdleCol($event, 'changedDate')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ formatChangedDate(row.changedDate) }}</td>
      </ng-container>

      <ng-container matColumnDef="event">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Event
          <app-table-column-filter class="column-filter" [class.active]="isActive('event')" (filterChange)="filterTabdleCol($event, 'event')" />
        </th>
        <td mat-cell *matCellDef="let row">{{ row.event }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
